<template>
  <div>
    <v-form>
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
                v-model="item.ref"
                :error-messages="refErrors"
                :label="$t('order.ref')"
                required
                @input="$v.item.ref.$touch()"
                @blur="$v.item.ref.$touch()"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
                v-if="designfileSelectItems"
                v-model="item.designFile"
                :items="designfileSelectItems"
                :error-messages="designfileErrors"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                :label="$t('designfile.designfile')"
                chips
                item-value="@id"
                item-text="name"
            >
              <template v-slot:selection>
                <v-chip
                    :key="item.designFile.name"
                >
                  <v-icon @mouseover="hover = true"
                          @mouseleave="hover = false"
                          left color="warning" v-if="item.designFile.nda">mdi-lock</v-icon>
                  <v-icon left v-else>mdi-lock-open</v-icon>
                  {{item.designFile.name}}
                </v-chip>
              </template>
            </v-combobox>
            <span v-if="hover" class="warning--text">{{$t('designfile.confidential')}}</span>
            <v-expansion-panels v-model="expansionOpen"  @click="openExpansionPanel">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{ $t('designfile.add') }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>

                  <DesignFileCreate :sub="true" @close="closeExpansionPanel" :customer="item.customer" :type="item.type"></DesignFileCreate>

                </v-expansion-panel-content>

              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" md="6" >
            <v-combobox ref="customerForm"
                        v-if="customerSelectItems"
                        v-model="item.customer"
                        :items="customerSelectItems"
                        :error-messages="customerErrors"
                        :no-data-text="$t('global.no_result')"
                        :placeholder="$t('global.no_select')"
                        clearable
                        :label="$t('customer.customer')"
                        item-text="name"
                        item-value="@id"
            />
            <v-btn  @click="addCustomer">{{$t('customer.create')}}</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
                v-if="typeSelectItems"
                v-model="item.type"
                :items="typeSelectItems"
                :error-messages="typeErrors"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                :label="$t('order.type')"
                item-text="name"
                item-value="@id"
            />

            <v-combobox
              v-if="prioritySelectItems"
              v-model="item.priority"
              :items="prioritySelectItems"
              :error-messages="priorityErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('priority.priority')"
              item-text="name"
              item-value="@id"
          />
          
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
              v-if="tagSelectItems"
              v-model="item.tags"
              :items="tagSelectItems"
              :error-messages="tagErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('order.tags')"
              item-text="name"
              item-value="@id"
              :search-input.sync="search"
              multiple
              chips
              :return-object="true"
              variant="solo-inverted"
              @change="changeTag()"
          >


              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t('global.no_result') }} "<strong>{{ search }}</strong>". {{ $t('global.addcombo1') }} <kbd>enter</kbd> {{ $t('global.addcombo2') }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-slot:selection="{ attrs, item, parent, selected }">
                <v-chip
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    color="accent"
                    :input-value="selected"
                    label
                >
                     <span class="pr-2">
                       {{ item.name }}
                     </span>
                  <v-icon
                      small
                      @click="parent.selectItem(item)"
                  >
                    mdi-close
                  </v-icon>
                </v-chip>
              </template>
            </v-combobox>
          </v-col>

          <v-col cols="12" sm="6" md="6">
            <v-text-field
                v-model.number="item.quantity"
                :error-messages="quantityErrors"
                :label="$t('order.quantity')"
                required
                @input="$v.item.quantity.$touch()"
                @blur="$v.item.quantity.$touch()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
                v-if="materialSelectItems"
                v-model="item.material"
                :items="materialSelectItems"
                :error-messages="materialErrors"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                :label="$t('order.material')"
                item-text="name"
                item-value="@id"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
                v-if="orderresolutionSelectItems"
                v-model="item.resolution"
                :items="orderresolutionSelectItems"
                :error-messages="resolutionErrors"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                :label="$t('order.resolution')"
                item-text="name"
                item-value="@id"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
                v-if="sectorSelectItems"
                v-model="item.sector"
                :items="sectorSelectItems"
                :error-messages="sectorErrors"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                :label="$t('order.sector')"
                item-text="name"
                item-value="@id"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
                v-if="verticaleSelectItems"
                v-model="item.verticale"
                :items="verticaleSelectItems"
                :error-messages="verticaleErrors"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                :label="$t('order.verticale')"
                item-text="name"
                item-value="@id"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-textarea
                v-model="item.comment"
                :error-messages="commentErrors"
                :label="$t('order.comment')"
                auto-grow
                rows="1"
                row-height="15"
                @input="$v.item.comment.$touch()"
                @blur="$v.item.comment.$touch()"
            />
          </v-col>
        </v-row>
      </v-container>

      <Loading :visible="isLoading" />
    </v-form>


  </div>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import { date } from '../../validators/date';
import Customer from "@/services/customer";
import DesignFileCreate from "@/views/designfile/Create.vue";
import NotificationMixin from '../../mixins/NotificationMixin';

export default {
  name: 'OrderForm',
  mixins: [validationMixin,NotificationMixin],
  components: {
    DesignFileCreate,
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },
    defaultvalues: {
      type: Object,
      required: false
    },
    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  mounted() {
    this.designfileGetSelectItems();
    this.customerGetSelectItems();
    this.typeGetSelectItems();
    this.orderstateGetSelectItems();
    this.priorityGetSelectItems();
    this.operatorGetSelectItems();
    this.sectorGetSelectItems();
    this.materialGetSelectItems();
    this.commercialGetSelectItems();
    this.tagGetSelectItems();
    this.verticaleGetSelectItems();
    this.orderresolutionGetSelectItems();
  },

  data() {
    return {
      ref: null,
      designFile: null,
      customer: null,
      type: null,
      state: null,
      sector: null,
      material: null,
      priority: null,
      quantity: null,
      delivery: null,
      comment: null,
      tags: null,
      search: null,
      verticale: null,
      resolution: null,

      addClientOption : false,
      hover: false,
      expansionOpen: null,
    };
  },

  computed: {
    isLoading() {
      return (this.isLoading_type ||
          this.isLoading_customer ||
          this.isLoading_orderstate ||
          this.isLoading_designfile ||
          this.isLoading_priority ||
          this.isLoading_tag ||
          this.isLoading_sector ||
          this.isLoading_material ||
          this.isLoading_commercial ||
          this.isLoading_operator ||
          this.isLoading_verticale ||
          this.isLoading_orderresolution

      );
    },
    ...mapFields('customer', {
      customerSelectItems: 'selectItems',
      isLoading_customer : 'isLoading'
    }),
    ...mapFields('designfile', {
      designfileSelectItems: 'selectItems',
      isLoading_designfile : 'isLoading'
    }),
    ...mapFields('ordertype', {
      typeSelectItems: 'selectItems',
      isLoading_type : 'isLoading'
    }),
    ...mapFields('orderstate', {
      orderstateSelectItems: 'selectItems',
      isLoading_orderstate : 'isLoading'
    }),
    ...mapFields('sector', {
      sectorSelectItems: 'selectItems',
      isLoading_sector : 'isLoading'
    }),
    ...mapFields('material', {
      materialSelectItems: 'selectItems',
      isLoading_material : 'isLoading'
    }),
    ...mapFields('priority', {
      prioritySelectItems: 'selectItems',
      isLoading_priority : 'isLoading'
    }),
    ...mapFields('user', {
      commercialSelectItems: 'selectItems',
      isLoading_commercial : 'isLoading'
    }),
    ...mapFields('user', {
      operatorSelectItems: 'selectItems',
      isLoading_operator : 'isLoading'
    }),
    ...mapFields('tag', {
      tagSelectItems: 'selectItems',
      isLoading_tag : 'isLoading'
    }),
    ...mapFields('verticale', {
      verticaleSelectItems: 'selectItems',
      isLoading_verticale : 'isLoading'
    }),
    ...mapFields('orderresolution', {
      orderresolutionSelectItems: 'selectItems',
      isLoading_orderresolution: 'isLoading'
    }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    refErrors() {
      const errors = [];

      if (!this.$v.item.ref.$dirty) return errors;

      has(this.violations, 'ref') && errors.push(this.violations.ref);

      !this.$v.item.ref.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    designfileErrors() {
      const errors = [];
      if (!this.$v.item.designFile.$dirty) return errors;
      has(this.violations, 'designFile') && errors.push(this.violations.designFile);

      return errors;
    },
    customerErrors() {
      const errors = [];
      if (!this.$v.item.customer.$dirty) return errors;
      has(this.violations, 'customer') && errors.push(this.violations.customer);
      !this.$v.item.customer.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    typeErrors() {
      const errors = [];

      if (!this.$v.item.type.$dirty) return errors;

      has(this.violations, 'type') && errors.push(this.violations.type);
      !this.$v.item.type.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    materialErrors() {
      const errors = [];

      if (!this.$v.item.material.$dirty) return errors;

      has(this.violations, 'material') && errors.push(this.violations.material);


      return errors;
    },
    orderstateErrors() {
      const errors = [];
      if (!this.$v.item.state.$dirty) return errors;
      has(this.violations, 'state') && errors.push(this.violations.state);

      return errors;
    },
    sectorErrors() {
      const errors = [];

      if (!this.$v.item.sector.$dirty) return errors;

      has(this.violations, 'sector') && errors.push(this.violations.sector);

      return errors;
    },
    priorityErrors() {
      const errors = [];
      if (!this.$v.item.priority.$dirty) return errors;
      has(this.violations, 'priority') && errors.push(this.violations.priority);

      return errors;
    },
    deliveryErrors() {
      const errors = [];
      if (!this.$v.item.delivery.$dirty) return errors;
      has(this.violations, 'delivery') && errors.push(this.violations.delivery);
      errors.push(this.$t('global.field_required'));
      return errors;
    },
    quantityErrors() {
      const errors = [];

      if (!this.$v.item.quantity.$dirty) return errors;

      has(this.violations, 'quantity') && errors.push(this.violations.quantity);

      !this.$v.item.quantity.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    OperatorErrors() {
      const errors = [];

      if (!this.$v.item.operator.$dirty) return errors;

      has(this.violations, 'operator') && errors.push(this.violations.operator);

      !this.$v.item.operator.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    tagErrors() {
      const errors = [];

      if (!this.$v.item.tags.$dirty) return errors;

      has(this.violations, 'tags') && errors.push(this.violations.tags);


      return errors;
    },
    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);


      return errors;
    },
    verticaleErrors() {
      const errors = [];

      if (!this.$v.item.verticale.$dirty) return errors;

      has(this.violations, 'verticale') && errors.push(this.violations.verticale);

      return errors;
    },
    resolutionErrors() {
      const errors = [];

      if (!this.$v.item.resolution.$dirty) return errors;

      has(this.violations, 'resolution') && errors.push(this.violations.resolution);


      return errors;
    },

  },

  methods: {
    closeExpansionPanel() {
      this.expansionOpen = null
      this.designfileGetSelectItems()
    },
    openExpansionPanel() {
      this.expansionOpen = 0
    },
    ...mapActions('customer', ['create']),
    ...mapActions({
      designfileGetSelectItems: 'designfile/fetchSelectItems',
      customerGetSelectItems: 'customer/fetchSelectItems',
      typeGetSelectItems: 'ordertype/fetchSelectItems',
      orderstateGetSelectItems: 'orderstate/fetchSelectItems',
      priorityGetSelectItems: 'priority/fetchSelectItems',
      commercialGetSelectItems: 'user/fetchSelectItems',
      sectorGetSelectItems:'sector/fetchSelectItems',
      materialGetSelectItems:'material/fetchSelectItems',
      operatorGetSelectItems: 'user/fetchSelectItems',
      tagGetSelectItems: 'tag/fetchSelectItems',
      verticaleGetSelectItems: 'verticale/fetchSelectItems',
      orderresolutionGetSelectItems: 'orderresolution/fetchSelectItems',
    }),
    changeTag() {
      this.item.tags = this.item.tags.map(v => {
        if (typeof v === 'string') {
          v = {
            name: v,
          }
        }
        return v
      })
      const seen = new Set(); //évite les doublons
      this.item.tags = this.item.tags.filter(tag => { //parcours des tags
        const key = tag.name.toLowerCase(); //évite la casse
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      this.search = "";
    },


    addCustomer() {
      //on met cette fonction dans un sleep car sinon la variable item.customer ne s'initialse pas (TO DO BETTER)
      setTimeout(() => {
      const name = this.item.customer;
      if (!name) {
        this.showError('error add name customer');
        return null;
      }
      if (name == '' || name.length < 2) {
        this.showError('error add name customer');
        return null;
      } else {
        
      Customer.create({"name" : name})
          .then(async () => {
            this.addClientOption = false;
            this.customerGetSelectItems()
          })
      }
      
      }, (500 ));
 

    }
  },
  watch: {

    prioritySelectItems() {
      if (this.item.priority == null ) {
        for (var i = 0; i < this.prioritySelectItems.length; i++) {
          if (this.prioritySelectItems[i].init ) {
            this.item.priority = this.prioritySelectItems[i];
          }
        }
      }
    },
    orderstateSelectItems() {
      if (this.item.state == null ) {
        for (var i = 0; i < this.orderstateSelectItems.length; i++) {
          if (this.orderstateSelectItems[i].init ) {
            this.item.state = this.orderstateSelectItems[i];
          }
        }
      }
    },
    orderresolutionSelectItems() {
      if (this.item.resolution == null ) {
        for (var i = 0; i < this.orderresolutionSelectItems.length; i++) {
          if (this.orderresolutionSelectItems[i].init ) {
            this.item.resolution = this.orderresolutionSelectItems[i];
          }
        }
      }
    },

    designfileSelectItems() {
      if (this.$route.params) {
        if (this.item.designFile == null && (this.$route.params.parent != null)) {
          for (var i = 0; i < this.designfileSelectItems.length; i++) {
            if (this.designfileSelectItems[i]['@id'] == this.$route.params.parent ) {
              this.item.designFile = this.designfileSelectItems[i];
              /*
                if (this.item.type == null) {
                  console.log();
                  this.item.type = this.designfileSelectItems[i].type;
                }
              */
            }
          }
        }
      }
    },
    sectorSelectItems() {
      if (this.$route.params) {
        if (this.item.sector == null && (this.$route.params.parent != null)) {
          for (var i = 0; i < this.sectorSelectItems.length; i++) {
            if (this.sectorSelectItems[i]['@id'] == this.$route.params.parent ) {
              this.item.sector = this.sectorSelectItems[i];
            }
          }
        }
      }
    },
    verticaleSelectItems() {
      if (this.$route.params) {
        if (this.item.verticale == null && (this.$route.params.parent != null)) {
          for (var i = 0; i < this.verticaleSelectItems.length; i++) {
            if (this.verticaleSelectItems[i]['@id'] == this.$route.params.parent ) {
              this.item.verticale = this.verticaleSelectItems[i];
            }
          }
        }
      }
    },

  },

  validations: {
    item: {
      ref: {
        required,
      },
      designFile: {
      },
      customer: {
        required,
      },
      tags: {
      },
      type: {
        required,
      },
      state: {
      },
      priority: {
      },
      quantity: {
        required,
      },
      sector:{
      },
      operator: {
      },
      verticale:{
      },
      material:{
      },
      delivery: {
        date,
      },
      comment: {
      },
      resolution: {

      },
    }
  }
};
</script>
